import { useAppSelector } from '../app/hooks'
import { DashboardSlice } from '../features/dashboard/dashboardSlice'
import { DashboardWidgetType } from '../features/dashboard/types'

import { Dashboard } from '../schemas/DashboardSchema'

export const useDashboard = (): DashboardSlice => {
  const dashboardState = useAppSelector(({ dashboard }) => dashboard)
  return dashboardState
}

export const useDashboardData = (): Dashboard | null => {
  const dashboardData = useAppSelector(({ dashboard }) => dashboard.dashboardData)
  return dashboardData
}

export const useDashboardWidgetSetting = <T extends DashboardWidgetType>(widgetId: number): T => {
  const widgetSetting = useAppSelector(({ dashboard }) =>
    dashboard.dashboardData?.widgets?.find((widget) => widget?.widgetId === widgetId)
  )
  return widgetSetting as T
}
